const SvgSearch = () => (
	<svg width="1em" height="1em" viewBox="0 0 21 22" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M9.313 2.085a7.3 7.3 0 1 0 0 14.6 7.3 7.3 0 0 0 0-14.6ZM0 9.385a9.313 9.313 0 1 1 18.627 0A9.313 9.313 0 0 1 0 9.385ZM16.908 16.98a1.007 1.007 0 0 1 1.424 0l2.373 2.372a1.007 1.007 0 1 1-1.424 1.424l-2.373-2.373a1.007 1.007 0 0 1 0-1.424Z"
			fill="#100D3D"
		/>
	</svg>
)

export default SvgSearch
